export const getTabId = (): string => {
  const TAB_ID_KEY = 'cc-tab-id';
  let tabId = sessionStorage.getItem(TAB_ID_KEY);
  if (!tabId) {
    tabId = `${Date.now()}-${Math.random().toString(36).substring(2, 10)}`;
    sessionStorage.setItem(TAB_ID_KEY, tabId);
  }
  return tabId;
};
